/*
 * @Description:
 * @Date: 2024-01-15 15:02:30
 */
export enum ModelType {
  'BASIC_STYLE' = '101',
  'BASIC_STYLE_COLOR' = '101_1',
  'BASIC_STYLE_BIG_TITLE' = '101_2',
  'BASIC_STYLE_SMALL_TITLE' = '101_3',
  'BASIC_STYLE_PAGE_NO' = '101_4',
  'BASIC_STYLE_WATERMARK' = '101_5',
  'COVER' = '102',
  'DIRECTORY' = '103',
  'BACKGROUND_INTRO' = '1',
  'SAMPLE_SCOPE' = '2',
  'PROJECT_OVERVIEW' = '3',
  'PROJECT_EXE_STAT_BEFORE' = '4_1',
  'PROJECT_EXE_STAT_GENDER' = '4_2',
  'PROJECT_EXE_STAT_GENDER_SEX' = '4_2_1',
  'PROJECT_EXE_STAT_GENDER_AGE' = '4_2_2',
  'PROJECT_EXE_STAT_GENDER_AGE_MAN' = '4_2_3',
  'PROJECT_EXE_STAT_GENDER_AGE_WOMAN' = '4_2_4',
  'PROJECT_EXE_STAT_INTERVAL' = '4_3',
  'PROJECT_EXE_STAT_INTERVAL_TASK' = '4_3_1',
  'PROJECT_EXE_STAT_INTERVAL_PERCENT' = '4_3_2',
  'PROJECT_EXE_STAT_INTERVAL_ZWS' = '4_3_3',
  'PROJECT_RESEARCH' = '5',
  'PROJECT_RESEARCH_OVERVIEW' = '5_1',
  'PROJECT_RESEARCH_CHARTS' = '5_2',
  'PROJECT_RESEARCH_PERCENT' = '5_3',
  'PROJECT_RESEARCH_ZWS' = '5_4',
  'CROSS_KAFANG_ANALYSIS' = '6',
  'CROSS_KAFANG_ANALYSIS_TABLE' = '6_1',
  'CROSS_KAFANG_ANALYSIS_CHARTS' = '6_2',
  'CROSS_KAFANG_ANALYSIS_CHARTS_TABLE' = '6_3',
  'SINGLE_FACTOR_MULTI_SAMPLE' = '7',
  'SINGLE_FACTOR_MULTI_SAMPLE_TABLE' = '7_1',
  'SINGLE_FACTOR_MULTI_SAMPLE_CHARTS' = '7_2',
  'HEAT_MAP' = '16',
  'EXAMPLE_SHARING' = '8',
  'PROJECT_EXE_FLOW' = '9',
  'PROJECT_EXE_PROGRESS' = '10',
  // 专区历史数据浏览效果评价
  'ZONE_HISTORY_EVALUATION' = '18',
  // 各篇浏览内容排行
  'ZONE_HISTORY_EVALUATION_RANK' = '18_1',
  // 浏览分布区域热力图
  'ZONE_HISTORY_EVALUATION_HOT' = '18_2',
  // 单日浏览走势图
  'ZONE_HISTORY_EVALUATION_TREND' = '18_3',
  // 各篇内容单日最大浏览量排名
  'ZONE_HISTORY_EVALUATION_DAY' = '18_4',
  // 本次专区反馈效果评价
  'ZONE_EVALUATION_CURRENT' = '19',
  // 各篇内容反馈排行
  'ZONE_EVALUATION_CURRENT_RANK' = '19_1',
  // 反馈分布区域热力图
  'ZONE_EVALUATION_CURRENT_HOT' = '19_2',
  // 单日反馈走势图
  'ZONE_EVALUATION_CURRENT_TREND' = '19_3',
  // 各篇内容单日最大反馈量排名
  'ZONE_EVALUATION_CURRENT_DAY' = '19_4',
  // 推广相关问卷数据分析
  'PROMOTION_ANALYSIS' = '20',
  // 各篇内容有效点击量排名
  'CONTENT_HIT_RATE_RANKING' = '21',
  // 各篇内容有效点击排行
  'CONTENT_HIT_RATE_RANKING_CLICK' = '21_1',
  // 各篇内容有效点击排行-表格样式
  'CONTENT_HIT_RATE_RANKING_CLICK_TABLE' = '21_1_1',
  // 各篇内容有效点击排行-图标样式
  'CONTENT_HIT_RATE_RANKING_CLICK_GRAPH' = '21_1_2',
  // 有效点击分布区域热力图
  'CONTENT_HIT_RATE_RANKING_MAP' = '21_2',
  // 单日有效点击走势图
  'CONTENT_HIT_RATE_RANKING_TREND' = '21_3',
  // 单日点击量Top5日期分布图
  'CONTENT_HIT_RATE_RANKING_DISTRIBUTE' = '21_4',
  // 单日点击量Top5占周期总有效点击量占比分析图
  'CONTENT_HIT_RATE_RANKING_PROPORTION' = '21_5',
  // 各篇内容单日最大有效点击量排名
  'CONTENT_HIT_RATE_RANKING_VALID' = '21_6',
  // 单篇内容有效点击量分析图
  'ARTICLE_CLICK_ANALYSIS' = '22'
}

export const SCENE_MAPPING = {
  5: {
    label: '调研',
    value: 5,
    content: [
      '101',
      '102',
      '103',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '16',
      '9',
      '10'
    ],
    sort: 1
  },
  20: {
    label: '可配置',
    value: 20,
    content: [
      '101',
      '102',
      '103',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '16',
      '8',
      '9',
      '10'
    ],
    sort: 2
  },
  21: {
    label: '数字问卷',
    value: 21,
    content: ['101', '102', '103', '1', '3', '4', '18', '19', '20', '9', '10'],
    sort: 3
  },
  6: {
    label: '数字专区',
    value: 6,
    content: ['101', '102', '103', '1', '3', '4', '21', '22', '9', '10'],
    sort: 4
  }
};
export const STATUS_MAPPING = {
  1: {
    label: '启用',
    value: 1
  },
  2: {
    label: '关闭',
    value: 2
  }
};
